var App = App || {};

App.ReseachDatabaseLinks = (function ($) {
	'use strict';


	const removeFavText = "Click to remove from favorites";
	const addFavText = "Click to add to favorites";

	function init() {

		var isHeartMode = false;

		function ResearchDatabaseDetailModel() {
			var self = this;
			self.title = ko.observable("");
			self.body = ko.observable("");
			self.imgSrc = ko.observable("");
			self.imgAlt = ko.observable("");
			self.restrictions = ko.observableArray([]);
		}


		var detailVM = new ResearchDatabaseDetailModel();
		var researchDatabaseModal = document.getElementById("researchDatabaseDetailModal");
		if (researchDatabaseModal)
			ko.applyBindings({ detail: detailVM }, researchDatabaseModal);


		$(document).on("click", "[data-mode='detail']:not(.heart):not(.removable)", function (e) {
			e.preventDefault();
			e.stopPropagation();

			detailVM.title($(this).data("title"));
			detailVM.body(decodeHtml($(this).data("body")));
			detailVM.imgSrc($(this).data("img-src"));
			detailVM.imgAlt($(this).data("img-alt"));
			detailVM.restrictions($(this).data("restrictions") || []);

			$("#researchDatabaseDetailModal").modal("show");
		});

		function decodeHtml(html) {
			var txt = document.createElement("textarea");
			txt.innerHTML = html;
			return txt.value;
		}

		function ResearchDatabasePurchaseModel() {
			var self = this;
			self.title = ko.observable("");
			self.body = ko.observable("");
			self.price = ko.observable("");
			self.key = ko.observable("");
		}


		var purchaseVM = new ResearchDatabasePurchaseModel();
		var purchaseOffcanvas = document.getElementById("researchDatabasePurchaseOffcanvas");
		if (purchaseOffcanvas)
			ko.applyBindings({ purchase: purchaseVM }, purchaseOffcanvas);


		$(document).on("click", "[data-mode='purchase']:not(.heart):not(.removable)", function (e) {
			e.preventDefault();
			e.stopPropagation();

			purchaseVM.title($(this).data("title"));
			purchaseVM.body(decodeHtml($(this).data("body")));
			purchaseVM.price($(this).data("price"));
			purchaseVM.key($(this).data("key"));

			$("#researchDatabasePurchaseOffcanvas").offcanvas("show");
		});

		function ResearchDatabaseSpeedbumpModel() {
			var self = this;
			self.id = ko.observable("");
			self.title = ko.observable("");
			self.body = ko.observable("");
			self.imgSrc = ko.observable("");
			self.imgAlt = ko.observable("");
			self.directLink = ko.observable("");
			self.continueText = ko.observable("");
		}


		var speedbumpVM = new ResearchDatabaseSpeedbumpModel();
		var speedbumpModal = document.getElementById("researchDatabaseSpeedbumpModal");
		if (speedbumpModal)
			ko.applyBindings({ speedbump: speedbumpVM }, speedbumpModal);


		$(document).on("click", "[data-mode='speedbump']:not(.heart):not(.removable)", function (e) {
			e.preventDefault();
			e.stopPropagation();

			speedbumpVM.id($(this).data("id"));
			speedbumpVM.title($(this).data("title"));
			speedbumpVM.body(decodeHtml($(this).data("body")));
			speedbumpVM.imgSrc($(this).data("img-src"));
			speedbumpVM.imgAlt($(this).data("img-alt"));
			speedbumpVM.directLink($(this).data("direct-link"));
			speedbumpVM.continueText("Continue to " + $(this).data("title"));

			$("#researchDatabaseSpeedbumpModal").modal("show");
		});

		$(document).on("click", "[data-mode='direct']:not(.heart):not(.removable)", function (e) {
			e.preventDefault();

			const $el = $(this);
			const directLink = ($el.attr("data-direct-link") || $el.data("directLink") || $el.data("direct-link") || "").trim();
			const id = ($el.attr("data-id") || $el.data("id") || "").trim();

			if (!directLink)
				return false;

			const link = document.createElement("a");
			link.href = directLink;
			link.target = "_blank";
			link.rel = "noopener";
			document.body.appendChild(link);
			link.click();
			link.remove();
			if (id) {
				try {
					fetch(`/api/database/log/${encodeURIComponent(id)}`, {
						method: "GET",
						cache: "no-store",
						keepalive: true,
						credentials: "same-origin"
					});
				} catch { /* ignore */ }
			}

			return false;
		});

		//////////////////////////////////////////////////////////////////////////
		// Favorites mode — ACCOUNT-BASED (no cookies)
		//////////////////////////////////////////////////////////////////////////

		var favoriteIds = [];

		getFavoritesFromAccount()
			.then((ids) => {
				favoriteIds = Array.isArray(ids) ? ids.map(x => String(x).trim()) : [];
			})
			.catch(() => {
				favoriteIds = [];
			})
			.then(() => {
				populateFavoritesAccount(false);
			});




		async function getFavoritesFromAccount() {
			var favoritesList = $(".research-database-masthead .favorites-list");
			if (!favoritesList || favoritesList.length === 0)
				return;

			const r = await fetch("/api/member_favorites", { credentials: "include" });
			const j = await r.json();

			const ok = r.ok && (j?.success === true || j?.status === "Success");
			if (!ok) {
				return [];
			}
			return Array.isArray(j?.data?.ids) ? j.data.ids : [];
		}


		async function saveFavoritesToAccount(ids) {

			const r = await fetch("/api/member_favorites", {
				method: "POST",
				credentials: "include",
				headers: {
					"Content-Type": "application/json",

				},
				body: JSON.stringify({ ids: Array.from(new Set(ids)) })
			});
			const j = await r.json();

			const ok = r.ok && (j?.success === true || j?.status === "Success");
			if (!ok) throw new Error(j?.message || "Unable to save favorites.");

			return Array.isArray(j?.data?.ids) ? j.data.ids : [];
		}

		function toggleFavoriteId(id) {
			var i = favoriteIds.indexOf(id);
			if (i >= 0) favoriteIds.splice(i, 1); else favoriteIds.push(id);
		}

		function populateFavoritesAccount(isHeart) {
			var databaseLists = $(".block-subpage-researchdatabases .researchdatabases-links-list");
			var favoritesList = $(".research-database-masthead .favorites-list");

			// mark in main list
			databaseLists.find("a.standalone").removeClass("filled-heart");
			favoriteIds.forEach(function (id) {
				databaseLists.find('a.standalone[data-id="' + id + '"]').addClass("filled-heart");
			});

			// clone into masthead
			favoritesList.empty();
			favoriteIds.forEach(function (id) {
				var $src = databaseLists.find('a.standalone[data-id="' + id + '"]');
				if ($src.length === 0) return;


				var $clone = $src.clone()
					.removeClass("heart filled-heart");

				favoritesList.append($clone);
			});

			if (isHeart) {
				favoritesList.find("a.standalone").addClass("removable").find(".temporary-aria").remove();
				var temp = $('<div>').text("Click to remove from favorites").addClass("sr-only temporary-aria");
				favoritesList.find("a.standalone").append(temp);
			} else {
				favoritesList.find("a.standalone").removeClass("removable").find(".temporary-aria").remove();
			}
		}





		// 2) Manage / Done Managing button
		$(document).on("click", ".research-database-masthead .btn-favorites-toggle", async function (e) {
			e.preventDefault();

			var databaseLists = $(".block-subpage-researchdatabases .researchdatabases-links-list");
			var databaseLinks = databaseLists.find("a.standalone");
			var favoritesLinks = $(".favorites-list a.standalone");

			if (isHeartMode) {
				// leaving heart mode -> SAVE to account
				try { await saveFavoritesToAccount(favoriteIds); } catch { }

				$(this).find(".text").text("Manage Favorites");
				$(this).find(".sr-only").text($("#favorites-sr").text());

				toggleFavoritesMode(favoritesLinks, isHeartMode);
				toggleDatabasesMode(databaseLinks, isHeartMode);

				isHeartMode = false;
				populateFavoritesAccount(isHeartMode);
			} else {
				$(this).find(".text").html("Done Managing\<br \/\>Favorites");
				$(this).find(".sr-only").text($("#done-sr").text());

				// pre-fill hearts for already-favorited items
				favoriteIds.forEach(function (id) {
					databaseLists.find('a.standalone[data-id="' + id + '"]').addClass("filled-heart");
				});

				toggleFavoritesMode(favoritesLinks, isHeartMode);
				toggleDatabasesMode(databaseLinks, isHeartMode);

				isHeartMode = true;
				populateFavoritesAccount(isHeartMode);
			}
		});

		// 3) While in heart mode, clicking a link toggles favorite 
		$(document).on("click", ".researchdatabases-links-list .standalone, .research-database-masthead .standalone", function (e) {
			if (!isHeartMode) return;
			e.preventDefault();

			var clickedId = $(this).attr("data-id");
			if (!clickedId) return;

			toggleFavoriteId(clickedId);
			populateFavoritesAccount(isHeartMode);
		});





		$(document).on("click", "button.add-to-cart", function (e) {
			var product = $(this).attr("data-key"),
				$offcanvas = $(e.currentTarget).closest(".offcanvas");

			App.Commerce.Add(
				product,
				null, 1
			).done(function () {
				$offcanvas.offcanvas("hide");
			});
		});


	}



	function toggleFavoritesMode(favoritesLinks, isHeartMode) {
		if (isHeartMode) {
			favoritesLinks.removeClass("removable");
			//remove explanation text from favorites
			favoritesLinks.find(".temporary-aria").remove();
			favoritesLinks.find(".sr-only").attr("aria-hidden", "false");
		}
		else {
			favoritesLinks.addClass("removable");

			//add sr-only explanation text to favorites
			favoritesLinks.find(".sr-only").attr("aria-hidden", "true");
			var tempAria = $('<div>');
			tempAria.text(removeFavText).addClass("sr-only temporary-aria");
			favoritesLinks.append(tempAria);
		}
	}

	function toggleDatabasesMode(databaseLinks, isHeartMode) {
		if (isHeartMode) {
			databaseLinks.removeClass("heart");
			//remove explanation text from listed databases
			databaseLinks.find(".temporary-aria").remove();
			databaseLinks.find(".sr-only").attr("aria-hidden", "false");
		}
		else {
			databaseLinks.addClass("heart");
			//add sr-only explanation to listed databases
			databaseLinks.find(".sr-only").attr("aria-hidden", "true");

			databaseLinks.each(function (index) {
				var tempAria = $('<div>');
				tempAria.addClass("sr-only temporary-aria");
				if ($(this).hasClass("filled-heart")) {
					tempAria.text(removeFavText);
				} else {
					tempAria.text(addFavText);
				}
				$(this).append(tempAria);
			});
		}
	}

	return {
		init: init
	};

})(jQuery);

$(function () {

	App.ReseachDatabaseLinks.init();
});